(() => {
  document.addEventListener('toggle', event => {
    const group = event.target;
    if (!group.matches('[data-aj-nav-group]') || !group.open) return;
    const menu = group.closest('[data-aj-navigation]');
    menu.querySelectorAll('[data-aj-nav-group][open]').forEach(other => {
      if (other !== group) other.open = false;
    });
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('[data-aj-navigation]')) return;
    document.querySelectorAll('.aj-nav-list--desktop [data-aj-nav-group][open]').forEach(group => { group.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    const group = active.closest('[data-aj-nav-group][open]') || document.querySelector('.aj-nav-list--desktop [data-aj-nav-group][open]');
    if (!group) return;
    group.open = false;
    group.querySelector('summary').focus();
    event.preventDefault();
  });
  document.addEventListener('focusin', event => {
    document.querySelectorAll('.aj-nav-list--desktop [data-aj-nav-group][open]').forEach(group => {
      if (!group.contains(event.target)) group.open = false;
    });
  });
})();
